/*
 * @Author: EdwardYoung
 * @Date: 2017-07-27 11:58:13
 * @Last Modified by: EdwardYoung
 * @Last Modified time: 2017-07-27 14:37:05
 */

 /**
  * fn 拉取函数
  * successor 下一个链表节点
  */
class Chain {
  constructor (fn) {
    this.fn = fn
    this.successor = null
  }

  setNextSuccessor (Chain) {
    this.successor = Chain
  }
  /**
   *  fn接收Player判断返回值whichData
   *  根据返回判断是否执行下一个节点函数
   */
  goBargain (player) {
    const whichData = this.fn.apply(null, arguments)
    if (whichData === 'next') {
      return this.successor && this.successor.goBargain.apply(this.successor, arguments)
    }
  }
}

export {Chain}



// WEBPACK FOOTER //
// ./src/common/js/bargainChain.js